// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3i90F","cell":"ColumnAccessor_cell__23kkI","firstCellAccent":"ColumnAccessor_firstCellAccent__2dGPh"};